import Mapper from '@/models/mappers/Mapper';
import { Font } from '@/models/entities/Font';
import { FontDTO } from '@/api/dto/FontDTO';
import { mapValueToInterface } from '@/utils/models';

export class FontMapper extends Mapper<Font, FontDTO> {
  mapFromDTO(fontDTO: FontDTO): Font {
    return new Font(<Partial<Font>>fontDTO);
  }

  mapToDTO(font: Font): FontDTO {
    return mapValueToInterface(font) as FontDTO;
  }
}
